import { useMutation, useQueryClient } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'
import { useAuth } from '../../contexts/AuthContext'

/**
 * 上位プランへの即時変更（BillingPage）。
 *
 * 成功時はリロードせず、AuthContext の再取得とお支払い履歴の無効化で整合する。
 * 呼び出し側は結果（請求された差額を含む）を受け取って完了画面へ遷移する。
 * リロードすると請求額を完了画面へ渡せず、利用者はいくら請求されたか分からない。
 */
export function useUpgradeSubscription() {
  const { refreshUser } = useAuth()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (planType: string) => billingApi.upgradeSubscription(planType),
    onSuccess: async () => {
      // 差額は履歴へ計上済み。開いたままのお支払い履歴へ反映する
      await queryClient.invalidateQueries({ queryKey: ['payment-history'] })
      await refreshUser()
    },
  })
}
